var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_116_836)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.8403,
    cy: 38.8402,
    r: 33,
    transform: "rotate(11.3304 38.8403 38.8402)",
    fill: "#F4B7EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3739 27.8401C39.8505 25.9224 42.8851 26.5305 43.509 28.869L44.498 32.5764C44.7458 33.505 45.4346 34.2523 46.3401 34.5746L49.9548 35.8616C52.2349 36.6735 52.5943 39.7474 50.563 41.0634L47.3428 43.1497C46.5361 43.6723 46.0383 44.5583 46.0115 45.519L45.9045 49.3546C45.837 51.7739 43.0246 53.0657 41.1453 51.5405L38.166 49.1225C37.4197 48.5169 36.4232 48.3172 35.5012 48.5886L31.8204 49.6721C29.4985 50.3555 27.4009 48.0799 28.2707 45.8213L29.6497 42.2406C29.9951 41.3437 29.8771 40.3343 29.3341 39.5413L27.1662 36.3754C25.7987 34.3784 27.3147 31.6802 29.7316 31.8095L33.5631 32.0145C34.5229 32.0659 35.4464 31.6417 36.0328 30.8802L38.3739 27.8401Z",
    fill: "#F09EE3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_116_836",
    x: 4.83398,
    y: 4.83386,
    width: 70.0127,
    height: 70.0128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_836"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_116_836",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.234dc975a5d606fb6be472aa51f28a82.svg";
export { ForwardRef as ReactComponent };